window.addEventListener('DOMContentLoaded', () => {
  const isMobile = document.body.classList.contains('is-mobile');
  const agenda = document.querySelector('.Agenda--Online');

  if (isMobile === true && agenda != null) {
    const tabs = agenda.querySelectorAll('.tab');
    const clonedContainer = document.createElement('div');
    clonedContainer.classList.add('container');
    const clonedTabsWrapper = document.createElement('div');
    clonedTabsWrapper.classList.add('Agenda-row-days', 'row', 'row--aligned');

    const newPosition = document.querySelector('.tab-content');
    newPosition.after(clonedContainer);
    clonedContainer.appendChild(clonedTabsWrapper);

    tabs.forEach(el => {
      if (!el.classList.contains('is-active')) {
        const cloneTab = el.cloneNode(true);
        clonedTabsWrapper.appendChild(cloneTab);
        el.style.display = 'none';
      }
    });
  }
});
